// extracted by mini-css-extract-plugin
export var icon = "socials-module--icon--b708a";
export var wrapper = "socials-module--wrapper--c015b";